/* eslint-disable max-classes-per-file */
import { IExpressionBasedEntity } from './IExpressionBasedEntity';
import { DataFlowExpression } from './dataflowexpression';
import { AnyDataFlowType, BaseDataFlowDataType, DataFlowDataType, IDataFlowDataType } from 'app/model/dataflow/dataflow-datatype';
import { DataFlowUtils } from 'app/authoring/component/transformations/dataFlow-utils';
import { IBasedOnEntity, IBasedOnEntityRef, DataFlowColumn } from '../dataset/dataflowcolumn';

export class ComplexFieldRef implements IBasedOnEntityRef {
    constructor(public field: ComplexField, public path: string, public rootColumn: DataFlowColumn,
        public isHierarchyLevelSpecified: boolean = false, public hierarchyRelativePath: string = '', public deepHierarchyisApplied: boolean = false) {}

    public get entity(): ComplexField {
        return this.field;
    }

    public get rootEntity(): DataFlowColumn {
        return this.rootColumn;
    }

    public get name(): string {
        return `${this.path}.${this.originalName}`;
    }

    public get hierarchicalName(): string {
        if (this.hierarchyRelativePath) {
            return `${this.hierarchyRelativePath}.${this.originalName}`;
        }
        return this.originalName;
    }

    public get originalName(): string {
        return this.entity.entityName;
    }

    public get owningStreamName(): string {
        return '';
    }

    public get siblingEntities(): ComplexField[] {
        return this.field.parentType.fields;
    }
}

export class ComplexField implements IExpressionBasedEntity, IBasedOnEntity {
    constructor(public entityName: string, public dataFlowExpression: DataFlowExpression, public parentType: ComplexDataFlowType) {}

    public get name(): string {
        return this.entityName;
    }

    public get originalName(): string {
        return this.entityName;
    }

    public get dataFlowColumnType(): IDataFlowDataType {
        return this.dataFlowExpression && this.dataFlowExpression.returnType;
    }
}

export class ComplexDataFlowType extends BaseDataFlowDataType {
    public static TYPE: DataFlowDataType = 'complex';
    public typeString: DataFlowDataType = ComplexDataFlowType.TYPE;
    public fields: ComplexField[] = [];
    public get typeInDsl(): string {
        const dslFields: string[] = [];
        this.fields.forEach((field) => {
            const escapedName = DataFlowUtils.needToEscape(field.entityName) ? `{${field.entityName}}` : field.entityName;
            dslFields.push(`${escapedName} as ${field.dataFlowExpression && field.dataFlowExpression.returnType ? field.dataFlowExpression.returnType.typeInDsl : AnyDataFlowType.TYPE}`);
        });
        return `(${dslFields.join(', ')})`;
    }
}

export class ExternalDataFlowType extends BaseDataFlowDataType {
    public static TYPE: DataFlowDataType = 'external';
    public typeString: DataFlowDataType = ExternalDataFlowType.TYPE;

    public get typeInDsl(): string {
        return `typeOf(${this.expression.expression})`;
    }

    constructor(public expression: DataFlowExpression = new DataFlowExpression()) {
        super();
    }
}
